// sort-imports-ignore
import "react-native-get-random-values";
import "./src/utils/Translations/intlPolyfills";

/**
 * This index / indexTwo pattern exists to make sure react-native-get-random-values is
 * the very first thing in the bundle. Otherwise it gets upset.
 */
import "./indexTwo.js";
